import { useAppConfig } from "../components/AppConfig"

export default useAppConfig
